import { useAuth } from '../../hooks/useAuth';

export const AccesoDenegado = () => {
  const { handlerLogout } = useAuth();

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          <div>
            <div className="centrado-vertical-error">
              <div className="col-md-12 text-center" style={{ paddingTop: '60px' }}>
                <h1>Acceso Denegado</h1>
                <h3>Su usuario no tiene permisos para acceder a la aplicación.</h3>
                <p>
                  Comuníquese con el administrador del sistema para solicitar los permisos
                  correspondientes.
                </p>
                <button
                  className="btn btn-primary text-white boton-nuevo"
                  onClick={handlerLogout}
                >
                  Salir
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
